import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
import location from './location.json';
const state = {
    browser_id:null
};
const getters = {
};

const actions = {
    [actionType.GET_LIST_OF_CUSTOMER]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/admin/customers?name=${params.name}&orderBy=${params.order_by}&page=${params.page}`, params).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_LIST_ADS_OF_CUSTOMER]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/admin/pub/customer/${params.id}?page=${params.page}`, params).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_IMPRESSIONS]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/admin/pub/${params.id}/impressions?from=${params.from}&to=${params.to}&group_by=${params.group_by}`).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_CLICK]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/admin/pub/${params.id}/clicks?from=${params.from}&to=${params.to}&group_by=${params.group_by}`).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_CTR]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/admin/pub/${params.id}/ctr?from=${params.from}&to=${params.to}&group_by=${params.group_by}`).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GENERATE_ADS_REPORT]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`admin/pub/${params.id}/report?from=${params.from}&to=${params.to}&group_by=${params.group_by}`, {
                responseType: 'blob',
                headers: { 'Accept': 'application/pdf' },
            }).then(result => {
                if (result) {
                    resolve(result)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.SEND_ADS_REPORT]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.post(`admin/pub/${params.id}/report?from=${params.from}&to=${params.to}&group_by=${params.group_by}`, { "email": params.email}).then(result => {
                if (result.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.UPDATE_GOOGLE_CLIENT_ID]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.put(`/admin/pub-locations/google/clientid`, params).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_GOOGLE_CLIENT_ID]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/admin/pub-locations/google/clientid`).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.CREATE_CUSTOMER]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.post(`/admin/customers`, params).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.UPDATE_CUSTOMER]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            
            api.put(`/admin/customers/${params.id}`, params).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.DELETE_CUSTOMER]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.delete(`/admin/customers/${params.id}`).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_ADVERTISMENT_LOCATIONS_FOR_SCREEN]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.post(`/admin/pub-locations`, params).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_ADVERTISMENT_FOR_LOCATIONS]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/admin/pub/location/${params.id}?finished=${params.active}`).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.CREATE_ADVERTISMENT_FOR_LOCATIONS]: async function ({ commit }, params) {
        
        return new Promise((resolve, reject) => {
            api.post(`/admin/pub`, params.obj).then(result => {
                if (result.data.data) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.DELETE_ADVERTISMENT_FOR_LOCATIONS]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.delete(`/admin/pub/${params.id}`).then(result => {
                if (result.data.success) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_CUSTOMER_LIST_FOR_ADS]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/admin/customers/list?name=${params.searchText}`).then(result => {
                if (result.data.success) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_CUSTOMER_DETAILS]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/admin/customers/${params.id}`).then(result => {
                if (result.data.success) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.MAKE_ADS_ACTIVE]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.put(`/admin/pub/${params.id}/active`,{}).then(result => {
                if (result.data.success) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.SWITCH_GOOGLE_ADS]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.put(`/admin/pub-locations/${params.id}/google`,{google_ad_key:params.google_ad_key,google_ad_on:params.google_ad_on}).then(result => {
                if (result.data.success) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_BROWSER_ID]: function ({ commit }, params) {
        commit(mutationType.SET_BROWSER_ID, params);
    },
    //public website
    [actionType.GETADS_FOR_PUBLIC_WEBSITE]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/pub/single?browser_id=${state.browser_id}&location_short_name=${location[params.id]}`).then(result => {
                if (result.data.success) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GETADS_FOR_PUBLIC_WEBSITE_MULTIPLE]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/pub/multiple?browser_id=${state.browser_id}&location_short_name=${location[params.id]}`).then(result => {
                if (result.data.success) {
                    resolve(result.data)
                }
            })
                .catch(error => reject(error));
        });
    },
    [actionType.CLICK_BANNERADS]: async function ({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.post(`/pub/${id}/click?browser_id=${state.browser_id}`,{})
                .catch(error => reject(error));
        });
    },
    [actionType.GET_GOOGLE_CLIENT_ID_PUBLIC]: async function ({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.get(`/pub/google/clientid`)
            .then(result => {
                if (result.data.success) {
                    resolve(result.data)
                }
            })
            .catch(error => reject(error));
        });
    },
    [actionType.ADS_CONTACT]: async function ({ commit }, parms) {
        return new Promise((resolve, reject) => {
            api.post(`/pub/contact`,parms)
            .then(result => {
                if (result) {
                    resolve(result)
                }
            })
            .catch(error => reject(error));
        });
    },
};

const mutations = {
    [mutationType.SET_BROWSER_ID](state, browser_id) {
        state.browser_id = browser_id;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}